import React, { useEffect, useState, useRef } from 'react';
import { ProgressBar } from 'react-bootstrap';
import {
  fetchOutsourceProgress,
  createOutsourceProgress,
  updateOutsourceProgress,
  fetchOutsourceStages,
} from '../../../services/api';

const STAGE_ORDER = [
  'Business Requirements',
  'Project Documentation',
  'Technical Questions',
  'Analysis',
  'Recommended Tech Stack',
  'Estimation',
  'Proposal',
  'Contract',
];

const getProgressVariant = (percentage) => {
  if (percentage < 25) return 'danger';
  if (percentage < 50) return 'warning';
  if (percentage < 75) return 'info';
  return 'success';
};

const OutsourceProgressBar = ({ requestId }) => {
  const [percentage, setPercentage] = useState(0);
  const [progressId, setProgressId] = useState(null);
  const intervalRef = useRef(null);

  const calculateAndUpdateProgress = async () => {
    try {
      // 1) Fetch all stages and all progress entries in parallel
      const [allStages, allProgress] = await Promise.all([
        fetchOutsourceStages(),
        fetchOutsourceProgress(),
      ]);

      // 2) From all stages, pick only those belonging to this requestId
      const stagesForRequest = allStages.filter(
        (stage) => Number(stage.outsource_request) === Number(requestId)
      );

      // 3) Count how many of the predefined 8 steps have a non-empty document_link
      const completedCount = STAGE_ORDER.reduce((count, stageType) => {
        // find the matching stage record (if any) for this stageType
        const key = stageType.toLowerCase().replace(/\s/g, '_');
        const matching = stagesForRequest.find((s) => s.stage_type === key);
        if (
          matching &&
          typeof matching.document_link === 'string' &&
          matching.document_link.trim() !== ''
        ) {
          return count + 1;
        }
        return count;
      }, 0);

      // 4) Always 8 total steps
      const totalCount = STAGE_ORDER.length; // 8
      const calculatedPercentage = Math.round((completedCount / totalCount) * 100);

      // 5) Immediately update UI if value changed
      setPercentage((prev) =>
        prev !== calculatedPercentage ? calculatedPercentage : prev
      );

      // 6) Persist to backend: either update existing progress record or create a new one
      const existingProgress = allProgress.find(
        (item) => Number(item.outsource_request) === Number(requestId)
      );

      if (existingProgress) {
        setProgressId(existingProgress.id);
        updateOutsourceProgress(existingProgress.id, {
          progress_percentage: calculatedPercentage,
        }).catch((err) => console.error('Failed to update progress:', err));
      } else {
        createOutsourceProgress({
          outsource_request: requestId,
          progress_percentage: calculatedPercentage,
        })
          .then((newProgress) => setProgressId(newProgress.id))
          .catch((err) => console.error('Failed to create progress:', err));
      }
    } catch (err) {
      console.error('Error calculating progress:', err);
    }
  };

  useEffect(() => {
    if (!requestId) return;

    // Run once immediately
    calculateAndUpdateProgress();

    // Then poll every 5 seconds for changes
    intervalRef.current = setInterval(() => {
      calculateAndUpdateProgress();
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [requestId]);

  const variant = getProgressVariant(percentage);

  return (
    <div className="mb-4">
  <div className="text-center fw-bold mb-2 text-primary fs-5">
    🚀 {percentage}% Complete
  </div>
  <ProgressBar
    now={percentage}
    label={<span className="text-white fw-bold fs-6">{percentage}%</span>}
    className="custom-progress"
  />
</div>

  );
};

export default OutsourceProgressBar;
